(ns ycweb.app.admin.wholesale.clientorders.clientorder.tabs.common
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as yuc]
   #?@(:clj
       []
       :cljs
       [[cljs-time.core :as dt]])))

(defn download-as-csv [data file-name]
  #?(:clj data
     :cljs
     (let [data-blob (js/Blob. #js [data] #js {:type "application/csv"})
           link (.createElement js/document "a")]
       (set! (.-href link) (.createObjectURL js/URL data-blob))
       (.setAttribute link "download" (str file-name "-" (dt/now) ".csv"))
       (.appendChild (.-body js/document) link)
       (.click link)
       (.removeChild (.-body js/document) link))))

(defn data-source-parameters [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)]
    {:client-order/uuid (:client-order/uuid client-order)}))

(defn default-date-fn [app-atom row col v]
  [:span (if (yuc/presence v) v "N/A")])

(defn format-stock-items [app-atom items title]
  [:div
   [:p title]
   [:ul
    (for [item items]
      [:li
       (str (:variation/fullname item)
         " - Ordered: " (:client-order-item/qty item)
         ", Available: " (:client-order-item/freestock item 0))])]])

(defn summary-calculations [items]
  (let [[additional-charges line-items]
        (yuc/separate
          #(w.cmn/service-variation? %)
          items)

        {:keys [additional-charges-total additional-charges-total-vat]}
        (reduce
          (fn [acc item]
            (let [{:line-item/keys [qty price calc-vat]} item]
              {:additional-charges-total (+ (:additional-charges-total acc) (* qty price))
               :additional-charges-total-vat (+ (:additional-charges-total-vat acc) calc-vat)}))
          {:additional-charges-total 0
           :additional-charges-total-vat 0}
          additional-charges)

        additional-charges-total-inc-vat (+ additional-charges-total additional-charges-total-vat)

        {:keys [line-items-total line-items-total-vat]}
        (reduce
          (fn [acc item]
            (let [{:line-item/keys [qty price discount calc-vat]} item
                  total (* qty price)
                  total-discount (* total (trf/topercentage discount))
                  discounted-total (- total total-discount)]
              {:line-items-total (+ (:line-items-total acc) discounted-total)
               :line-items-total-vat (+ (:line-items-total-vat acc) calc-vat)}))
          {:line-items-total 0
           :line-items-total-vat 0}
          line-items)

        line-items-total-inc-vat (+ line-items-total line-items-total-vat)

        total (+ line-items-total additional-charges-total)
        total-vat (+ line-items-total-vat additional-charges-total-vat)
        total-inc-vat (+ additional-charges-total-inc-vat line-items-total-inc-vat)]

    (->>
      {:additional-charges-total additional-charges-total
       :additional-charges-total-vat additional-charges-total-vat
       :additional-charges-total-inc-vat additional-charges-total-inc-vat
       :line-items-total line-items-total
       :line-items-total-vat line-items-total-vat
       :line-items-total-inc-vat line-items-total-inc-vat
       :total total
       :total-vat total-vat
       :total-inc-vat total-inc-vat}
      (reduce
        (fn [acc [k v]]
          (assoc acc k (trf/fromcurrency v)))
        {}))))

(rum/defc display-total-summary < rum/reactive
  [{:keys [additional-charges-total additional-charges-total-vat additional-charges-total-inc-vat
           line-items-total line-items-total-vat line-items-total-inc-vat
           total total-vat total-inc-vat] :as summary-data}]
  [:div
   {:class (yuc/bem :flex-grid-group [:flush :align-right :valign-middle])}
   [:div
    {:class (yuc/bem :flex-grid-block [:fluid])}
    [:div.flex-grid-content
     [:table
      {:class (yuc/bem :oTable [:has-shadow])}
      [:thead
       [:tr
        [:th]
        [:th "Order Lines"]
        [:th "Additional Charges"]
        [:th "Total"]]]
      [:tbody
       [:tr
        [:td "Before Tax:"]
        [:td.u-text-right
         ;; Before Tax Line Items total.
         (str (yuc/number-format line-items-total 2))]
        [:td.u-text-right
         ;; Before Tax Additional Charges total.
         (str (yuc/number-format additional-charges-total 2))]
        [:td.u-text-right
         ;; Before Tax Total.
         (str (yuc/number-format total 2))]]
       [:tr
        [:td "Tax:"]
        [:td.u-text-right
         ;; Tax total for Line items.
         (str (yuc/number-format line-items-total-vat 2))]
        [:td.u-text-right
         ;; Tax Additional Charges.
         (str (yuc/number-format additional-charges-total-vat 2))]
        [:td.u-text-right
         ;; Tax Total.
         (str (yuc/number-format total-vat 2))]]
       [:tr
        [:td [:b "Total:"]]
        [:td.u-text-right
         ;; Line items total.
         [:b (str (yuc/number-format line-items-total-inc-vat 2))]]
        [:td.u-text-right
         ;; Additional Charges total.
         [:b (str (yuc/number-format additional-charges-total-inc-vat 2))]]
        [:td.u-text-right
         ;; Absolute Total.
         [:b (str "R" (yuc/number-format total-inc-vat 2))]]]]]]]])

(defn product-render [app-atom row col v]
  (cond
    (yuc/presence (:brand/path row))
    (let [brand-parts (str/split (:brand/path row) #":")
          brand-root-name (first brand-parts)
          product-name
          (cond
            (str/starts-with? (:product/name row) brand-root-name)
            (str/replace (:product/name row) brand-root-name "")

            :else
            (:product/name row))]
      (str (:variation/name row) ": " (:brand/name row) " - " product-name))

    :else
    (str (:variation/name row) ": " (:product/name row))))

(defn price-render [app-atom row col v]
  [:span (str "R" (yuc/number-format v 2))])

(defn from-currency-fn [_ _ _ v]
  (trf/fromcurrency v))

(defn total-logic [_ _ _ v]
  (let [{:keys [qty price discount]} v
        discount-perc (trf/topercentage discount)
        total (* qty (trf/fromcurrency price))
        discount-amount (* total discount-perc)]
    (str "R" (yuc/number-format (- total discount-amount) 2))))

(rum/defc display-validation-message [app-atom validation-message]
  [:span validation-message])
